















import moment from 'moment'
import { computed, defineComponent } from '@vue/composition-api'
import {
  ISpecialOfferReceipt,
  SpecialOfferReceiptType,
} from '@/types/special-offer'
import { ngReasons } from '@/components/organisms/special-offer-receipts/SearchInput.vue'

type Props = {
  specialOfferReceipts: ISpecialOfferReceipt[]
  loading: boolean
  receiptType: SpecialOfferReceiptType
}

export default defineComponent({
  name: 'SpecialOfferReceiptsTable',
  props: {
    specialOfferReceipts: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store

    const headers = [
      { text: '受取日', value: 'importedAt' },
      { text: 'ID', value: 'id' },
      { text: 'TX ID', value: 'transactionId' },
      { text: '案件ID', value: 'specialOfferId' },
      { text: '案件管理名', value: 'specialOfferNameAdmin' },
      { text: '案件名', value: 'specialOfferTitle' },
      { text: 'リンカーステータス', value: 'linkerCheckStatus' },
      { text: 'リーダーステータス', value: 'leaderCheckStatus' },
      { text: 'NG理由', value: 'ngReason' },
    ]

    const items = computed(() =>
      props.specialOfferReceipts.map(q => {
        let linkerCheckStatus = '-'
        if (q.linkerOkedAt) {
          if (q.linkerNgedAt) {
            linkerCheckStatus = q.linkerNgedAt < q.linkerOkedAt ? 'OK' : 'NG'
          } else {
            linkerCheckStatus = 'OK'
          }
        } else {
          if (q.linkerNgedAt) {
            linkerCheckStatus = 'NG'
          }
        }
        let leaderCheckStatus = '-'
        if (q.leaderOkedAt) {
          if (q.leaderNgedAt) {
            leaderCheckStatus = q.leaderNgedAt < q.leaderOkedAt ? 'OK' : 'NG'
          } else {
            leaderCheckStatus = 'OK'
          }
        } else {
          if (q.leaderNgedAt) {
            leaderCheckStatus = 'NG'
          }
        }
        const ngReason =
          ngReasons.find(nr => nr.value === q.ngReason)?.text || null
        return {
          ...q,
          importedAt: moment(q.importedAt).format('YYYY/MM/DD HH:00'),
          specialOfferNameAdmin: q.specialOffer?.nameAdmin,
          specialOfferTitle: q.specialOffer?.title,
          linkerCheckStatus,
          leaderCheckStatus,
          ngReason,
        }
      }),
    )

    const onClickEditButton = async (
      item: Record<string, string | boolean>,
    ) => {
      await store.dispatch(
        'specialOfferReceipt/getSpecialOfferReceipt',
        item.id,
      )
      await store.dispatch(
        'specialOfferReceipt/setReceiptType',
        props.receiptType,
      )
      context.root.$router.push('/check-special-offer-receipt').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }

    return { props, headers, moment, items, onClickEditButton }
  },
})
